import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import englishContent from '../content/englishContent';
import hindiContent from '../content/hindiContent';

export const LANG_STORAGE_KEY = 'humpro-lang';

const LanguageContext = createContext(null);

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const s = localStorage.getItem(LANG_STORAGE_KEY);
      return s === 'hi' || s === 'en' ? s : 'en';
    } catch {
      return 'en';
    }
  });

  const content = lang === 'hi' ? hindiContent : englishContent;

  const setLang = useCallback((next) => {
    const L = next === 'hi' ? 'hi' : 'en';
    setLangState(L);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, L);
    } catch {
      /* ignore */
    }
  }, []);

  const t = useCallback(
    (path) => {
      const v = getByPath(content, path);
      return v !== undefined && v !== null ? v : path;
    },
    [content]
  );

  useEffect(() => {
    document.documentElement.lang = lang === 'hi' ? 'hi' : 'en';
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, content, t }), [lang, setLang, content, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  return ctx;
}

export function purposeLabelFromContent(content, value) {
  const opts = content?.contact?.form?.purposeOptions;
  if (!Array.isArray(opts)) return value;
  return opts.find((o) => o.value === value)?.label || value;
}
